import { useState } from 'react';
import { Layout } from 'antd';
import { Menu as MenuIcon } from 'lucide-react';
import BlockedMenuHeader from './BlockedMenuHeader';
import BlockedSideBarMenu from './BlockedSideBarMenu';
import useWindowSize from '../../hooks/useWindowSize';
import MyDrawer from '../../components/myDrawer/MyDrawer';
import MyLucideIcon from '../../components/myIcon/MyLucideIcon';
import MyFlexVertical from '../../components/myFlex/MyFlexVertical';
import MyDividerDiffColor from '../../components/myDivider/MyDividerDiffColor';
import './BlockedLayout.scss';

const { Sider } = Layout;

const BlockedLayoutSideMenu = () => {
  const { isMobile } = useWindowSize();

  const [menuOpen, setMenuOpen] = useState(false);

  return isMobile ? (
    <MyDrawer
      className="ant_drawer_left_menu_mobile"
      closable={false}
      size="min(70%, 320px)"
      onClose={setMenuOpen}
      open={menuOpen}
      btnClassName="mobile_menu_btn"
      icon={<MyLucideIcon icon={MenuIcon} />}
      placement="left"
      noExtraBtn
    >
      <BlockedMenuHeader />
      <MyDividerDiffColor />
      <BlockedSideBarMenu />
    </MyDrawer>
  ) : (
    <Sider width={260} className="main_sider">
      <MyFlexVertical gap={0}>
        <BlockedMenuHeader />
        <MyDividerDiffColor />
        <BlockedSideBarMenu />
      </MyFlexVertical>
    </Sider>
  );
};

export default BlockedLayoutSideMenu;
